import { ItemCondition, ItemState } from '../../models/item-details'
import type { OwnItemDetails } from './own-item-details-component/own-item-details-component.types'

/** Minimal props so `OwnItemDetailsComponent` can render the same skeleton layout as before data loads */
export const OWN_ITEM_LOADING_SHELL: OwnItemDetails = {
  listedItemId: 0,
  isCurrentUserOwner: true,
  name: '',
  description: '',
  itemCondition: ItemCondition.New,
  currentPrice: 0,
  state: ItemState.Active,
  donorName: '',
  nonprofit: { nonprofitId: 0, externalId: '0' },
  nonprofitName: '',
  images: [],
  version: '',
  city: '',
  region: '',
  isLocalPickupAvailable: false,
  isShippingAvailable: false,
}
